import gsap from 'gsap';
import * as THREE from 'three';
import { useGSAP } from '@gsap/react';
import { useEffect, useRef, useState } from 'react';
import { View } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';

import ModalView from './ModalView';
import { yellowImg } from '../utils';
import { models, sizes } from '../constants';
import { animateWithGsapTimeline } from '../utils/animation';

const Model = () => {
    const [size, setSize] = useState<'small' | 'large'>('small');
    const [model, setModel] = useState({
        title: 'iPhone 15 Pro in Natural Titanium',
        color: ['#8F8A81', '#FFE7B9', '#6F6C64'],
        img: yellowImg,
    });

    // camera control
    const cameraControlSmall = useRef();
    const cameraControlLarge = useRef();

    // model
    const small = useRef(new THREE.Group());
    const large = useRef(new THREE.Group());

    // rotation
    const [smallRotation, setSmallRotation] = useState(0);
    const [largeRotation, setLargeRotation] = useState(0);
    const tl = gsap.timeline();

    useEffect(() => {
        if (size === 'large') {
            animateWithGsapTimeline(
                tl,
                small,
                smallRotation,
                '#view1',
                '#view2',
                {
                    transform: 'translateX(-100%)',
                    duration: 2,
                }
            );
        }

        if (size === 'small') {
            animateWithGsapTimeline(
                tl,
                large,
                largeRotation,
                '#view1',
                '#view2',
                {
                    transform: 'translateX(0)',
                    duration: 2,
                }
            );
        }
    }, [size, smallRotation, largeRotation, tl]);
    useGSAP(() => {
        gsap.to('#heading', {
            y: 0,
            opacity: 1,
        });
    }, []);
    return (
        <section className="common-padding">
            <div className="screen-max-width">
                <h1 id="heading" className="section-heading">
                    TAKE A CLOSER LOOK.
                </h1>
                <div className="flex flex-col items-center mt-5">
                    <div className="w-full h-[75vh] md:h-[90vh] overflow-hidden relative">
                        <ModalView
                            index={1}
                            groupRef={small}
                            gsapType="view1"
                            controlRef={cameraControlSmall}
                            setRotationState={setSmallRotation}
                            item={model}
                            size={size}
                        />

                        <ModalView
                            index={2}
                            groupRef={large}
                            gsapType="view2"
                            controlRef={cameraControlLarge}
                            setRotationState={setLargeRotation}
                            item={model}
                            size={size}
                        />
                        <Canvas
                            className="size-full"
                            style={{
                                position: 'fixed',
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                overflow: 'hidden',
                            }}
                            eventSource={document.getElementById('root')!}>
                            <View.Port />
                        </Canvas>
                    </div>
                    <div className="mx-auto w-full">
                        <p className="text-center text-sm font-light mb-5">
                            {model.title}
                        </p>
                        <div className="flex-center">
                            <div className="color-container">
                                {models.map((mod, i) => (
                                    <button
                                        type="button"
                                        key={i + 'listItem'}
                                        className="w-6 h-6 rounded-full mx-2 cursor-pointer"
                                        style={{
                                            backgroundColor: mod.color[0],
                                        }}
                                        onClick={() => setModel(mod)}>
                                        {}
                                    </button>
                                ))}
                            </div>
                            <span className="size-btn-container">
                                {sizes.map(({ label, value }) => (
                                    <button
                                        type="button"
                                        key={label}
                                        className="size-btn transition-all"
                                        style={{
                                            backgroundColor:
                                                size === value
                                                    ? 'white'
                                                    : 'transparent',
                                            color:
                                                size === value
                                                    ? 'black'
                                                    : 'white',
                                        }}
                                        onClick={() => {
                                            if (
                                                value === 'small' ||
                                                value === 'large'
                                            ) {
                                                setSize(value);
                                            }
                                        }}>
                                        {label}
                                    </button>
                                ))}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Model;
